import { Box } from '@mui/material';
import { Checkbox, NumericInput } from '../form-controls.jsx';
import { Grid } from '../layout.jsx';

export function NitrogenInputs() {
  return (
    <Grid columns={2} spacing={{ xs: 2, sm: 3 }}>
      <Checkbox name="nitrogen.cornAfterCorn" label="Corn after Corn" />
      <Box />
      <NumericInput name="nitrogen.startN" label="Start N" />
      <NumericInput name="nitrogen.pivotN" label="Pivot N" />
    </Grid>
  );
}
